import React, { useEffect, useState, useCallback } from "react";
import { useIntl } from 'react-intl';
import { useSelector } from "react-redux";

// Components
import Select from 'Components/Select';
import { Form } from 'Components';

// Helpers
import TriggerLandmark from "Modules/alerts/components/wizardAlert/common/components/TriggerLandmark";

const POWER_LOST_CODE = 'PowerLost'
const PARENT_ID_ALERTS = 45

export const CameraEvent = (props) => {

    const { value, onChange, formRef, triggers, triggersRaw } = props
    const { messages, locale } = useIntl()

    useEffect(() => {
        if (value.cameraEvents == undefined)
            onChange({
                ...value,
                cameraEvents: ''
            })
    }, [value])

    // const dropdownOptions = OrderData([
    //     { selectId: 'PotentialIncident', name: messages['alertsNewAlert_PotentialIncident'] },
    //     { selectId: 'RapidAcceleration', name: messages['alertsNewAlert_RapidAcceleration'] },
    //     { selectId: 'HardBrake', name: messages['alertsNewAlert_hardBrake'] },
    //     { selectId: 'HardTurn', name: messages['alertsNewAlert_hardTurn'] },
    //     //{ selectId: 'NoDriver', name: messages['alertsNewAlert_noDriver'] },
    //     { selectId: 'Asleep', name: messages['alertsNewAlert_asleep'] },
    //     { selectId: 'Drowsy', name: messages['alertsNewAlert_drowsy'] },
    //     { selectId: 'Yawn', name: messages['alertsNewAlert_yawn'] },
    //     { selectId: 'DayDreaming', name: messages['alertsNewAlert_dayDreaming'] },
    //     { selectId: 'UsingPhone', name: messages['alertsNewAlert_usingPhone'] },
    //     { selectId: 'Distracted', name: messages['alertsNewAlert_distracted'] },
    //     { selectId: 'Smoking', name: messages['alertsNewAlert_smoking'] },
    //     { selectId: 'NoSeatbelt', name: messages['alertsNewAlert_noSeatbelt'] },
    //     { selectId: 'Manual', name: messages['alertsNewAlert_manual'] },
    //     { selectId: 'ForwardCollisionWarning', name: messages['alertsNewAlert_collisionWarning'] },
    //     { selectId: 'HeadwayMonitoringWarning', name: messages['alertsNewAlert_closeFollowing'] },
    //     { selectId: 'HeadwayMonitoringEmergency', name: messages['alertsNewAlert_tailgating'] },
    //     { selectId: 'PowerOff', name: messages['alertsNewAlert_powerOff'] },
    //     { selectId: 'StopSignViolation', name: messages['alertsNewAlert_stopSignViolation'] },
    //     { selectId: 'NoDriver', name: messages['videoMainView_noDriver'] },
    //     { selectId: 'LaneDeparture', name: messages['videoMainView_laneDeparture'] },
    //     { selectId: 'NewDriverFaceDetected', name: messages['videoMainView_newDriverFaceDetected'] },
    //     { selectId: 'PostedSpeed', name: messages['videoMainView_PostedSpeed'] },
    //     { selectId: 'SpeedThreshold ', name: messages['videoMainView_speedThreshold'] },
    //     { selectId: 'PedestrianDetection', name: messages['videoMainView_pedestrianDetection'] },
    //     { selectId: 'CyclistWarning', name: messages['videoMainView_cyclistWarning'] },
    //     { selectId: 'PassengerInside', name: messages['videoMainView_passengerInside'] },
    //     { selectId: 'PassengerSeatbelt', name: messages['videoMainView_passengerSeatbelt'] }
    // ], 'name');

    const [events, setEvents] = useState([])
    const { alertTypesSupported } = useSelector(state => state.alertsWizardRedux)
    const [showErrorTrigger, setShowErrorTrigger] = useState(false)

    useEffect(() => {
        if (alertTypesSupported && alertTypesSupported?.length > 0) {
            let listAlertFilter = alertTypesSupported?.filter((alert) => alert.parentId === PARENT_ID_ALERTS);
            const filterNamesAndOrder = listAlertFilter?.map(alert => {
                if(alert?.code === POWER_LOST_CODE){
                    return {
                        ...alert,
                        name: messages['alertsNewAlert_MainPowerDisconnect']
                    }
                }
                return { ...alert, name: messages[alert.name] || alert.name }
            })
            filterNamesAndOrder?.sort((a, b) => a.name.localeCompare(b.name));
            setEvents(filterNamesAndOrder);
        }
    }, [alertTypesSupported, locale])

    const handleTriggerChange = useCallback((newConfig, newTriggers) => {
        onChange(newConfig, newTriggers);
    }, [onChange]);

    return (
        <Form ref={formRef}
            onSubmit={() => {
                if (value.trigger) {
                    let isValid = triggersRaw?.length > 0

                    if (!isValid) {
                        setShowErrorTrigger(true)
                    } else setShowErrorTrigger(false)
                    return isValid
                }
            }}
        >
            <Select
                label={messages['alertsNewAlert_Event']}
                requiredMessage={messages['required_field']}
                value={events.filter((item) => value?.cameraEvents?.includes(item?.code))  || []}
                placeholder={messages['alertsNewAlert_SelectPlaceholder']}
                onChange={(selected) => {
                    onChange({ ...value, cameraEvents: selected?.map((element) => element?.code) || '' })
                }}
                id="cameraEventSelect"
                options={events}
                textField="name"
                valueField="code"
                required
                multiple 
                isChips
            />

            <TriggerLandmark 
                config={value} 
                triggers={triggers} 
                triggersRaw={triggersRaw} 
                onChange={handleTriggerChange} 
                showErrorTrigger={showErrorTrigger} 
            />
        </Form>
    );
}
